import { connect } from 'react-redux';

import Drawer from './Drawer';

const mapStateToProps = (state) => ({
  open: state?.state?.drawerOpen,
});

export default connect(mapStateToProps)(Drawer);
